import React from 'react';
import { isStaleChunkError, reloadForStaleChunk } from '../../utils/staleChunkReload';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, componentStack: '', reloading: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error, reloading: isStaleChunkError(error) };
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error('ErrorBoundary caught an error', error, info);
        if (isStaleChunkError(error) && reloadForStaleChunk(error)) {
            this.setState({ reloading: true, componentStack: info?.componentStack || '' });
            return;
        }
        this.setState({ reloading: false, componentStack: info?.componentStack || '' });
    }

    render() {
        const { hasError, error, componentStack, reloading } = this.state;
        const { children } = this.props;
        if (hasError && reloading) {
            return (
                <div style={{ padding: 16 }}>
                    <h2>Mise à jour de l&apos;application</h2>
                    <p>Une nouvelle version est disponible. Rechargement en cours.</p>
                </div>
            );
        }
        if (hasError) {
            return (
                <div style={{ padding: 16 }}>
                    <h2>Une erreur s'est produite</h2>
                    <pre style={{ whiteSpace: 'pre-wrap' }}>{String(error)}</pre>
                    {componentStack && (
                        <details style={{ whiteSpace: 'pre-wrap', marginTop: 8 }}>
                            <summary>Trace du composant</summary>
                            {componentStack}
                        </details>
                    )}
                    <p>Essayez d'actualiser la page. Si le problème persiste, utilisez /logout pour réinitialiser la session.</p>
                </div>
            );
        }
        return children;
    }
}
